import { render, staticRenderFns } from "./LanguageIso.vue?vue&type=template&id=03c28bad&"
import script from "./LanguageIso.vue?vue&type=script&lang=ts&"
export * from "./LanguageIso.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports